import {
  notificationConversationIdentity,
  notificationExcerpt,
  notificationMetadata
} from './notificationPresentation';

export const teamMessageNotification = (payload, actorKey) => {
  const { message, conversation } = payload || {};
  const conversationId = payload?.conversationId || conversation?.id || message?.conversationId;
  if (!actorKey || !message?.id || !conversationId || !message.sender?.actorKey ||
      message.sender.actorKey === actorKey) return null;
  const sender = message.sender.displayName || 'Team member';
  const attachments = Array.isArray(message.attachments) ? message.attachments : [];
  return {
    toastId: `team:${conversationId}:${message.id}`,
    type: 'team_message',
    title: sender,
    message: message.body || (attachments.length === 1
      ? `Sent an attachment: ${attachments[0].filename || 'File'}`
      : attachments.length ? `Sent ${attachments.length} attachments` : 'New message'),
    metadata: {
      conversationId,
      conversation: {
        ...conversation,
        id: conversationId,
        kind: conversation?.kind || 'direct',
        name: conversation?.kind === 'group' ? conversation.name || 'Team group' : sender
      }
    }
  };
};

export const notificationToastDetails = (notification) => {
  const { channel, conversationId } = notificationConversationIdentity(notification) || {};
  const metadata = notificationMetadata(notification);
  const messageChat = ['team', 'sms', 'live_chat'].includes(channel) && Boolean(conversationId);
  const label = channel === 'team'
    ? metadata.conversation?.kind === 'group'
      ? `Team · ${metadata.conversation.name || 'Group message'}` : 'Team message'
    : channel === 'sms' ? 'Customer message'
      : channel === 'live_chat' ? 'Website chat' : 'Notification';
  const title = channel === 'sms'
    ? metadata.customerName || metadata.customerPhone || notification.title || 'Customer'
    : notification.title || 'New message';
  return {
    key: notification.toastId || `notification:${notification.id}`,
    conversationKey: messageChat ? `${channel}:${conversationId}` : null,
    title: String(title),
    label,
    excerpt: notificationExcerpt(notification.message || (messageChat ? 'Sent an attachment' : ''), 160),
    actionable: messageChat || String(notification.actionUrl || '').startsWith('/app/'),
    messageChat
  };
};

// Coalesce bursts from a conversation, but keep other conversations waiting.
// Both the pending queue and replay cache are bounded for long-running tabs.
export const enqueueNotificationToast = (queue, notification) => {
  const details = notificationToastDetails(notification);
  const previous = queue.find((item) => item.key === details.key ||
    (details.conversationKey && item.conversationKey === details.conversationKey));
  if (previous?.key === details.key) return queue;
  const entry = { ...details, notification, count: (previous?.count || 0) + 1 };
  return previous
    ? queue.map((item) => item === previous ? entry : item)
    : [...queue.slice(-19), entry];
};

export const rememberNotification = (seen, key) => {
  if (seen.has(key)) return false;
  seen.add(key);
  if (seen.size > 500) seen.delete(seen.values().next().value);
  return true;
};

export const openConversationNotification = (notification) => {
  const { channel, conversationId } = notificationConversationIdentity(notification) || {};
  if (!conversationId) return false;
  const metadata = notificationMetadata(notification);
  const targets = {
    sms: ['autoclever:open-customer-message', { customerId: conversationId }],
    team: ['autoclever:open-team-message', { conversationId, conversation: metadata.conversation }],
    live_chat: ['autoclever:open-live-chat', { sessionId: conversationId }]
  };
  const target = targets[channel];
  if (!target) return false;
  window.dispatchEvent(new CustomEvent(target[0], { detail: target[1] }));
  return true;
};
